import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../../../config";
import "./ViewClientPage.css";

function ViewClientPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { leadId } = useParams();

  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [formData, setFormData] = useState({
    leadName: "",
    emailId: "",
    phoneNo: "",
    sourse: "",
    status: "",
    userType: "",
    _id: "",
  });
  const [invoices, setInvoices] = useState([]);

  // Fetch client details
  useEffect(() => {
    if (!leadId) return;
    axios
      .get(`${API_URL}/api/getClientLeadbyId/${leadId}`)
      .then((res) => {
        const user = res.data.user || res.data;
        setFormData({
          ...user,
          _id: user._id,
        });
      })
      .catch((err) => console.log(err));
  }, [leadId]);

  // Fetch projects for this client
  useEffect(() => {
    if (!formData._id) return;
    setLoading(true);
    axios
      .get(`${API_URL}/api/getProjectbyClient/${formData._id}`)
      .then((res) => {
        setProjects(res.data || []);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, [formData._id]);

  useEffect(() => {
    if (!formData._id) return;
    axios
      .get(`${API_URL}/api/getInvoicesByClient/${formData._id}`)
      .then((res) => {
        if (res.data && res.data.success) {
          setInvoices(res.data.invoices);
          console.log("Client _id:", formData._id);
          console.log("Fetched client invoices:", res.data.invoices);
        } else {
          setInvoices([]);
        }
      })
      .catch(() => setInvoices([]));
  }, [formData._id]);

  if (loading) {
    return <div className="client-view-state">Loading client data...</div>;
  }

  return (
    <div className="client-view-page">
      <div className="client-view-shell">
        <div className="client-view-topbar">
          <button className="client-view-back-btn" onClick={() => navigate(-1)}>
            Back
          </button>
        </div>

        <section className="client-view-hero">
          <div>
            <p className="client-view-overline">Client CRM</p>
            <h3>Client Details</h3>
            <span>Track profile, projects, and account status in one place</span>
          </div>
        </section>

        <section className="client-view-actions-card">
          <h5>Actions</h5>
          <div className="client-view-actions-row">
            <button
              className="client-view-btn add"
              onClick={() =>
                navigate(`/admin/addProject/${formData._id}`, {
                  state: { client: formData },
                })
              }
            >
              Add Project
            </button>

            <button
              className="client-view-btn invoice"
              onClick={() =>
                navigate(`/admin/invoice/${formData._id}`, {
                  state: { client: formData },
                })
              }
            >
              Invoice
            </button>

            <button
              className="client-view-btn view"
              onClick={() => navigate("/admin/projects", { state: { client: formData } })}
            >
              View Projects
            </button>

            <button
              className="client-view-btn muted"
              disabled={!formData._id}
              onClick={() => navigate(`/admin/clientInvoicesList/${formData._id}`)}
            >
              View Invoice
            </button>
          </div>
        </section>

        <section className="client-view-grid">
          <article className="client-view-card">
            <h6>Personal Details</h6>
            <div className="client-view-list">
              <p><strong>Name:</strong> {formData.leadName}</p>
              <p><strong>Email:</strong> {formData.emailId}</p>
              <p><strong>Phone:</strong> {formData.phoneNo}</p>
              <p><strong>Source:</strong> {formData.sourse}</p>
            </div>
          </article>

          <article className="client-view-card">
            <h6>Projects</h6>
            <div className="client-view-list">
              {projects.length > 0 ? (
                <>
                  {projects.map((proj) => (
                    <div key={proj._id} className="client-project-item">
                      <p><strong>Project Name:</strong> {proj.projectName}</p>
                      <p><strong>Price:</strong> Rs {proj.project_price || proj.price || "N/A"}</p>
                      <p><strong>Service:</strong> {proj.service?.serviceName || "N/A"}</p>
                    </div>
                  ))}
                </>
              ) : (
                <p className="client-view-muted">No project added yet.</p>
              )}
            </div>
          </article>
        </section>

        <section className="client-view-card status-card">
          <h6>Status and Assignment</h6>
          <div className="client-view-list">
            <p><strong>Status:</strong> {formData.status}</p>
            <p><strong>User Type:</strong> {formData.userType}</p>
          </div>
        </section>
      </div>
    </div>
  );
}

export default ViewClientPage;
